import PricingSection from "@/components/ui/pricing";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PricingDemo() {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-screen bg-neutral-100">
      {/* Back Button */}
      <div className="fixed top-6 left-6 z-50">
        <Button
          onClick={() => navigate("/")}
          variant="outline"
          className="bg-white/90 backdrop-blur-sm hover:bg-white shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-gray-200 hover:border-blue-600 group"
        >
          <ArrowLeft className="h-5 w-5 mr-2 group-hover:text-blue-600 transition-colors" />
          <span className="font-medium">Back to Home</span>
        </Button>
      </div>
      
      <PricingSection />
    </div>
  );
}
